export default __webpack_public_path__ + "static/media/map_2.955d4ff2.svg";